import { getCoreRowModel, getExpandedRowModel } from "@tanstack/react-table"
import type { ExpandedState } from "@tanstack/react-table"
import type { FC } from "react"
import { useState } from "react"

import { useTransferFormProductColumns } from "../../hooks"
import type { TransferFormProductInventory } from "../../types"

import { TransferFormProductRowDetails } from "./TransferFormProductRowDetails"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"

interface TransferFormProductTableProps {
  data: TransferFormProductInventory[]
  readOnly?: boolean
  onProductRemove: (productId: number) => void
  onPalletsSelect: (productId: number) => void
  onPalletOverride: (productId: number, palletReferenceNumber: number) => void
  onPalletRemove: (productId: number, palletReferenceNumber: number) => void
}

export const TransferFormProductTable: FC<TransferFormProductTableProps> = ({
  data,
  readOnly = false,
  onProductRemove,
  onPalletsSelect,
  onPalletOverride,
  onPalletRemove,
}) => {
  const [expanded, setExpanded] = useState<ExpandedState>({})
  const columns = useTransferFormProductColumns({ onProductRemove, onPalletsSelect, readOnly })

  return (
    <AerosBaseTable
      features={{
        table: {
          stickyHeader: true,
        },
        tanstackOptions: {
          data,
          columns,
          getRowId: (row) => String(row.product.productId),
          state: {
            expanded,
          },
          getCoreRowModel: getCoreRowModel(),
          getExpandedRowModel: getExpandedRowModel(),
          onExpandedChange: setExpanded,
          getRowCanExpand: () => true,
          renderExpandedContent: (row) => (
            <TransferFormProductRowDetails
              pallets={row.original.pallets}
              uomName={row.original.product.packageUsWeightUomDetails?.name ?? ""}
              readOnly={readOnly}
              onPalletOverride={(palletReferenceNumber) =>
                onPalletOverride(row.original.product.productId, palletReferenceNumber)
              }
              onPalletRemove={(palletReferenceNumber) =>
                onPalletRemove(row.original.product.productId, palletReferenceNumber)
              }
            />
          ),
        },
      }}
      slotProps={{
        bodyCell: { className: "align-top" },
        bodyCellExpanded: { className: "bg-primary-100" },
      }}
      noDataMessage='No products added yet'
    />
  )
}
